import { render } from "./menu.vue?vue&type=template&id=b46edd92&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=b46edd92&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b46edd92"

export default script